import React, { useEffect, useState } from 'react';
import ListUtils from '../../helpers/common/ListUtils';
import Popup from './Popup';
import TryAgain from './TryAgain';

/**
 * @param {StartOrTryAgainPopupArgs} param0 
 */
const StartOrTryAgainPopup = ({start, hasError, tryAgain, children}) => {

    if (tryAgain === undefined)
        tryAgain = {};

    tryAgain.hasCancel = tryAgain.hasCancel || false;
    tryAgain.onTryAgainClicked = tryAgain.onTryAgainClicked || start.onCloseClicked;

    function getLocale() {
        const languages = ["it", "de", "pl", "es", "fr"];
        const locale = navigator.language.slice(0, 2);
        return locale != undefined && languages.includes(locale) ? locale : "it";
      }
    
      const [locale, setLocale] = useState(getLocale());
    
      useEffect(() => {
        setLocale(getLocale());
      }, []);
    
        const strings = {   
            it: {
                start: "Inizia",
            },
            de: {
                start: "Startet",
            },
            pl: {
                start: "Start",
            },
            es: {
                start: "Comienza",
            },
            fr: {
                start: "Commence ",
            },
        };

    return (
        <Popup
            show={start.show}
            className={ListUtils.toHtmlClasses([
                start.className || "",
                "react-embedded-start",
            ])}
            style={start.style}
        >
            {!hasError
                ?

                <button type="button"
                    onClick={start.onCloseClicked}
                    disabled={start.disabled}
                    // TODO: localization
                >
                    {strings[locale].start}
                </button>

                :

                <TryAgain {...tryAgain}>
                    {children}
                </TryAgain>
            }
        </Popup>
    );
};

export default StartOrTryAgainPopup;
